/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useRef, useEffect, useContext } from 'react';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// service imports
import AuthService from '../../services/AuthService';
import GeneralService from '../../services/GeneralService';

// Add new imports
import { ClipLoader } from 'react-spinners';

const UserVerification = props => {

    // states
    const [response, setResponse] = useState({ isEmailVerified: false, isPhoneVerified: false, message: { msgError: false, msgBody: "" } });
    const [error, setError] = useState({ msgError: false, msgBody: "" });
    const [loading, setLoading] = useState(true);
    let timerID = useRef(null);

    //variables
    var user = { token: '', type: '' };

    const { theme } = useContext(ThemeContext);

    useEffect(() => {
        try {
            user.token = props.match.params.token;
            user.type = props.match.params.type;
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at User UserVerification useEffect', 'Error in try catch block', err.stack);
        }
        AuthService.verifyUser(user)
            .then(data => {
                try {
                    setResponse(data);
                    setLoading(false);
                    timerID = setTimeout(() => {
                        if(data.isPsychometricTest){
                            props.history.push('/psychometricTestLandingPage');
                        }else{

                            props.history.push('/user/signin');
                        }
                     
                    }, 2000);
                } catch (err) {
                    Alert.error("Some error occured, please try again later or report support team.", {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    GeneralService.logError('at User UserVerification useEffect', 'Error in try catch block', err.stack);
                }
            })
            .catch(error => {
                setResponse(error);
                setError(error.message);
                setLoading(false);
            })
        return () => {
            clearTimeout(timerID)
        }
    }, []);

    // function's return
    return (
        <div className="verification-container" style={{
            ...theme.psychometricLanding.container,
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <div className="rectangular-box" style={{
                ...theme.form,
                ...theme.psychometricLanding.box,
                textAlign: 'center',
                padding: 'clamp(2rem, 4vw, 4rem)',
                maxWidth: '600px',
                width: '90%'
            }}>
                
                {loading ? (
                    <div>
                        <ClipLoader color="#70B646" size={50} />
                        <h2 style={{
                            ...theme.headingBold,
                            color: '#70B646',
                            marginTop: '1rem'
                        }}>Verifying...</h2>
                    </div>
                ) : response.message.msgError ? (
                    <div>
                        <img 
                            src={require('../../assets/docAndPencilLogo.png')}
                            alt="Logo"
                            style={{
                                maxWidth: 'clamp(100px, 15vw, 150px)',
                                height: 'auto',
                                marginBottom: '1rem'
                            }}
                        />
                        <h2 style={{
                            ...theme.headingBold,
                            color: '#FF4444'
                        }}>{response.message.msgBody}</h2>
                    </div>
                ) : response.isEmailVerified || response.isPhoneVerified ? (
                    <div>
                        <img 
                            src={require('../../assets/docAndPencilLogo.png')}
                            alt="Logo"
                            style={{
                                maxWidth: 'clamp(100px, 15vw, 150px)',
                                height: 'auto',
                                marginBottom: '1rem'
                            }}
                        />
                        <h2 style={{
                            ...theme.headingBold,
                            color: '#70B646'
                        }}>
                            {response.isEmailVerified ? 
                                'Your email has been successfully verified!' : 
                                'Your phone has been successfully verified!'}
                        </h2>
                        <p style={theme.paragraphHeading}>
                            Redirecting you to {response.isPsychometricTest ? 
                                'the psychometric test' : 
                                'sign in'}...
                        </p>
                    </div>
                ) : null}
            </div>
        </div>
    )


}

export default UserVerification;